import { X, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function VisionPanel({ onClose }) {
  const navigate = useNavigate();

  return (
    <>
      {/* Overlay */}
      <div className="fixed inset-0 bg-black/60 z-40" onClick={onClose}></div>

      {/* Sliding Panel */}
      <div className="fixed right-0 top-0 h-full w-full max-w-4xl bg-white shadow-2xl z-50 overflow-y-auto animate-slide-in">

        {/* Top Spacer to clear navbar */}
        <div className="h-20 bg-white"></div>

        {/* Sticky Header */}
        <div className="sticky top-20 bg-white border-b border-gray-200 p-6 z-20">
          <div className="flex items-start justify-between">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 bg-green-600 rounded-lg flex items-center justify-center">
                  <Eye className="text-white" size={20} />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">Our Vision</h2>
              </div>
              <p className="text-sm text-gray-600">Leading global innovation in AI-powered marketing</p>
            </div>
            <button
              onClick={onClose}
              className="ml-4 w-10 h-10 flex items-center justify-center text-gray-400 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-all"
              aria-label="Close panel"
            >
              <X size={24} />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">

          {/* Vision Statement */}
          <div>
            <p className="text-base text-gray-700 leading-relaxed">
              To become the world's leading AI marketing platform for growing businesses, powering millions of companies across the globe with intelligent automation that drives real results.
            </p>
          </div>

          {/* Strategic Goals */}
          <div className="space-y-4">
            <div className="border-l-4 border-green-600 pl-4">
              <h4 className="text-base font-bold text-gray-900 mb-2">Global Market Leadership</h4>
              <p className="text-sm text-gray-600">Become the #1 AI marketing platform for SMEs worldwide, serving 100,000+ businesses across 50+ countries by 2030.</p>
            </div>

            <div className="border-l-4 border-green-600 pl-4">
              <h4 className="text-base font-bold text-gray-900 mb-2">AI Innovation Pioneer</h4>
              <p className="text-sm text-gray-600">Develop proprietary AI models that deliver better results, faster execution, and deeper insights than any competitor.</p>
            </div>

            <div className="border-l-4 border-green-600 pl-4">
              <h4 className="text-base font-bold text-gray-900 mb-2">Customer Success</h4>
              <p className="text-sm text-gray-600">Achieve 95% retention by ensuring every customer sees measurable ROI and business growth within their first 90 days.</p>
            </div>
          </div>

          {/* Roadmap */}
          <div className="bg-gray-50 border border-gray-200 p-5 rounded-lg">
            <h3 className="text-base font-bold text-gray-900 mb-3">Our Roadmap</h3>
            <div className="space-y-3 text-sm text-gray-700">
              <div>
                <span className="font-semibold text-gray-900">2026:</span> 25+ countries, 25,000+ active businesses
              </div>
              <div>
                <span className="font-semibold text-gray-900">2028:</span> 50,000+ businesses, advanced predictive analytics
              </div>
              <div>
                <span className="font-semibold text-gray-900">2030:</span> 100,000+ businesses, global market leader
              </div>
            </div>
          </div>

        </div>

        {/* CTA at Bottom */}
        <div className="sticky bottom-0 bg-white border-t border-gray-200 p-6">
          <button
            onClick={() => navigate('/signup')}
            className="w-full bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-semibold transition-all"
          >
            Start Free Trial
          </button>
        </div>
      </div>

      {/* Animation Styles */}
      <style jsx>{`
        @keyframes slide-in {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        .animate-slide-in {
          animation: slide-in 0.3s ease-out;
        }
      `}</style>
    </>
  );
}
